// ErrorBoundaryContext.tsx
import { createContext } from "react";
import Rollbar from "rollbar";

const ErrorBoundaryContext = createContext<Rollbar | null>(null);

export default ErrorBoundaryContext;
